import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { CALLS_FILTER_OPTIONS, FILTER_DROPDOWN_SIZES, FILTER_FIELD_CALLS, getFilterDropdownStyle } from '../consts';
import dropdownStyles from '../PresenceFilterDropdown/PresenceFilterDropdown.module.scss';

interface CallsFilterDropdownProps {
  onClose: () => void;
  selectedValue: string;
  onSelect: (value: string) => void;
}

export const CallsFilterDropdown = ({ onClose, selectedValue, onSelect }: CallsFilterDropdownProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onDocumentMouseDown = (event: MouseEvent) => {
      if (!dropdownRef.current) return;
      if (dropdownRef.current.contains(event.target as Node)) return;
      onClose();
    };

    document.addEventListener('mousedown', onDocumentMouseDown);
    return () => {
      document.removeEventListener('mousedown', onDocumentMouseDown);
    };
  }, [onClose]);

  return (
    <div
      className={dropdownStyles.dropdown}
      style={getFilterDropdownStyle(FILTER_DROPDOWN_SIZES[FILTER_FIELD_CALLS])}
      ref={dropdownRef}
    >
      {CALLS_FILTER_OPTIONS.map((item) => (
        <UnstyledButton
          key={item.value}
          className={clsx(dropdownStyles.option, selectedValue === item.value && dropdownStyles.optionSelected)}
          onClick={() => {
            onSelect(item.value);
            onClose();
          }}
        >
          <span>{item.label}</span>
        </UnstyledButton>
      ))}
    </div>
  );
};
